import { ApiService } from "./api.service";
import { Router } from "@angular/router";

import { Injectable } from '@angular/core';
import { ReferralModel } from "../models/referral.model";
//import { Observable, of } from 'rxjs';
import { IResponse } from "@bt/shared";

@Injectable()
export class ReferralService{

    constructor(private api: ApiService,
                private router: Router,){}


    public GetRefLink(): Promise<IResponse<ReferralModel>>{
        return this.api.get<ReferralModel>("api/referral/getreflink").toPromise();

    }


}


// WEBPACK FOOTER //
// ./src/app/core/services/referral.service.ts